import './App.css';
import Counseling from './components/Counseling';
import FAQ from './components/FAQ';
import FeaturedResults from './components/FeaturedResults';
import FloatingSidebar from './components/FloatingSidebar';
import Navbar from './components/Navbar';
import StudyMethod from './components/StudyMethod';
import Trailer from './components/Trailer';
import Financing from './components/Financing';
import Header from './components/Header';
import Master from './components/Master';
import Plans from './components/Plans';
import Memberships from './components/Memberships';
import HeaderForm from './components/HeaderForm';
import FooterNew from './components/FooterNew';

function App() {
	return (
		<div className='App'>
			<Navbar />
			{/* <FloatingSidebar /> */}
			<Header />
			<HeaderForm />
			<Master />
			{/* <Trailer /> */}
			{/* <StudyMethod /> */}
			<Plans />
			{/* <Memberships /> */}
			{/* <Financing /> */}
			<Counseling />
			{/* <FeaturedResults /> */}
			<FAQ />
			<FooterNew />
		</div>
	);
}

export default App;
